import {
  COLOR_DANGER,
  COLOR_LIGHT,
  COLOR_LINK,
  COLOR_MUTED,
  COLOR_PRIMARY,
  COLOR_SECONDARY,
  PLACEMENT_CENTER,
  PLACEMENT_LEFT,
  PLACEMENT_RIGHT,
  SIZE_LG,
  SIZE_MD,
  SIZE_SM,
  STATE_ACTIVE,
  STATE_DISABLED,
  STATE_FOCUS,
} from '../../config/constants';

export const BUTTON_BASE_CLASS = 'btn';

export const BUTTON_SIZES = [
  SIZE_SM,
  SIZE_MD,
  SIZE_LG,
];

export const BUTTON_COLORS = [
  COLOR_LIGHT,
  COLOR_PRIMARY,
  COLOR_DANGER,
  COLOR_LINK,
];

export const BUTTON_LINK_COLORS = [
  COLOR_LINK,
  COLOR_MUTED,
];

export const BUTTON_STATUS_TYPES = [
  COLOR_PRIMARY,
  COLOR_SECONDARY,
  COLOR_DANGER,
];

export const BUTTON_TEXT_ALIGNMENT = {
  PLACEMENT_CENTER,
  PLACEMENT_LEFT,
  PLACEMENT_RIGHT,
};

export const BUTTON_STATES = [
  STATE_FOCUS,
  STATE_ACTIVE,
  STATE_DISABLED,
];

export const BUTTON_RWD_SIZES = [
  SIZE_SM,
  SIZE_MD,
  SIZE_LG,
];
